import type { Product, Routine } from '../../core/types/catalog'

export const HOME_BESTSELLERS = 4
/** Zoveel flesjes op de plank van de homepage (schuifbaar). */
export const HOME_SHELF = 8
export const HOME_ROUTINES = 2
export const HOME_ARTICLES = 3

const completeFirst = (a: Routine, b: Routine) => Number(b.level === 'Compleet') - Number(a.level === 'Compleet')

/** Bestsellers en salonfavorieten. Puur. */
export function homeBestsellers(products: readonly Product[], count = HOME_BESTSELLERS): Product[] {
  return products.filter((p) => p.bestseller || p.salonFavourite).slice(0, count)
}

/**
 * "Uitgelicht" staat per protocol aan in het beheer; het complete protocol eerst.
 * Niets aangezet? Dan de eerste protocollen.
 */
export function featuredRoutines(routines: readonly Routine[], count = HOME_ROUTINES): Routine[] {
  const flagged = routines.filter((r) => r.featured).sort(completeFirst)
  return (flagged.length > 0 ? flagged : [...routines]).slice(0, count)
}
